import type { ReactHandleErrorInfo } from '@web-platform/shared-universal-types/src/react';

export const getErrorBoundaryStackMessage = (error: Error, info: ReactHandleErrorInfo): string => {
  let stackMessage = info.componentStack;

  if (error.stack) {
    stackMessage = `${error.stack}\n\n----COMPONENT STACK----\n${stackMessage}`;
  }

  return stackMessage;
};
